var _rect, _rect2, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFinland(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1800,
    height: 1100,
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1800,
    height: 1100,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1800,
    height: 300,
    y: 400,
    fill: "#003580"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 1100,
    x: 500,
    fill: "#003580"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinland);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxODAwIiBoZWlnaHQ9IjExMDAiPgo8cmVjdCB3aWR0aD0iMTgwMCIgaGVpZ2h0PSIxMTAwIiBmaWxsPSIjZmZmIi8+CjxyZWN0IHdpZHRoPSIxODAwIiBoZWlnaHQ9IjMwMCIgeT0iNDAwIiBmaWxsPSIjMDAzNTgwIi8+CjxyZWN0IHdpZHRoPSIzMDAiIGhlaWdodD0iMTEwMCIgeD0iNTAwIiBmaWxsPSIjMDAzNTgwIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };